import React from "react";
import { AlertTriangle, CalendarRange, Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { STATE, TONE_CHIP } from "@/lib/kapasitet";

export const OPEN_EVENT = "kapasitet:open";
export const openKapasitet = () => window.dispatchEvent(new Event(OPEN_EVENT));

export const kapTone = (k) => (STATE[k?.state]?.tone || "muted");
export const kapLabel = (k) => (k?.reservert && k.state !== "bekreftet" ? `${STATE[k.state]?.label || k.label} · reservert` : STATE[k?.state]?.label || k?.label || "Kapasitet");
export const kapSub = (k) => {
  if (!k) return null;
  if (k.state === "mangler_periode") return "Sett verkstedopphold for å kontrollere mot planen";
  if (k.state === "ikke_relevant") return null;
  const parts = [k.oppstart_uke ? `Oppstart ${k.oppstart_uke.toLowerCase()}${k.uker ? ` · ${k.uker} uke${k.uker > 1 ? "r" : ""}` : ""}` : null, ...(k.worst || []).slice(0, 2).map((w) => `${w.name} ${w.pct} %`), ...(k.ressurs_konflikt || []).map((r) => `${r} opptatt`), k.ufordelt_timer ? `${k.ufordelt_timer} t ufordelt` : null];
  return parts.filter(Boolean).join(" · ");
};

/** Small status chip (Kalkyle summary). Opens the control. */
export function KapasitetChip({ k, className, inert = false }) {
  const tone = kapTone(k);
  const Tag = inert ? "span" : "button";
  return (
    <Tag type={inert ? undefined : "button"} onClick={inert ? undefined : openKapasitet} className={cn("inline-flex h-8 items-center gap-1.5 rounded-full px-2.5 text-[12.5px] font-medium transition-[background-color,filter]", !inert && "hover:brightness-95", TONE_CHIP[tone], className)} title="Kapasitetskontroll – åpne" data-testid="kapasitet-chip" data-tone={tone} data-state={k?.state}>
      {tone === "ok" ? <Check className="h-3.5 w-3.5" strokeWidth={2.6} /> : tone === "bad" || tone === "warn" ? <AlertTriangle className="h-3.5 w-3.5" /> : <CalendarRange className="h-3.5 w-3.5" />} {kapLabel(k)}
    </Tag>
  );
}

/** Card in Tilbud's control sheet and in Kontroll: the promised period against the plan. Internal only. */
export function KapasitetCard({ k, testId = "tilbud-kapasitet-card" }) {
  if (!k || k.state === "ikke_relevant") return null;
  const tone = kapTone(k);
  return (
    <div className={cn("mb-4 rounded-[14px] border bg-white px-4 py-3", tone === "bad" ? "border-[hsl(var(--v-blocked)/0.35)]" : tone === "warn" ? "border-[hsl(var(--v-assumed)/0.35)]" : "border-black/[0.07]")} data-testid={testId} data-tone={tone} data-state={k.state}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
        <div className="flex items-center gap-2 text-[13px] font-medium"><CalendarRange className="h-4 w-4 text-[hsl(var(--navy))]" /> Kapasitet for lovet periode</div>
        <span className={cn("inline-flex h-6 items-center gap-1 rounded-full px-2 text-[11.5px] font-medium", TONE_CHIP[tone])} data-testid={`${testId}-pill`}>{kapLabel(k)}</span>
        <span className="text-[11.5px] text-muted-foreground">{kapSub(k)}</span>
        <button type="button" onClick={openKapasitet} className="ml-auto inline-flex h-7 items-center rounded-full bg-[hsl(var(--navy))] px-3 text-[12px] font-medium text-white hover:bg-[hsl(var(--ink-2))]" data-testid={`${testId}-open`}>{k.state === "mangler_periode" ? "Sett periode" : "Åpne kontrollen"}</button>
      </div>
      <p className="mt-1.5 text-[11.5px] text-muted-foreground">Beregnet mot bekreftet og reservert belegg – åpne tilbud vises som risiko, ikke som opptatt. En reservasjon lover ingenting til kunden.</p>
    </div>
  );
}
